var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"data-item"},[_c('section',{staticClass:"data-item-header"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('section',{staticClass:"data-item-body",style:({height:(_vm.bodyHeight + "px")})},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9b23b28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Data/DataItem.vue
// module id = null
// module chunks = 